import useAppDispatch from '@/hooks/useAppDispatch'
import useAppSelector from '@/hooks/useAppSelector'
import {
  selectReferralsImportHistorical,
  setIsOpen,
} from '@/redux/slices/referralsImportHistorical'

export function useImportHistoricalReferralsModal() {
  const isOpen = useAppSelector(selectReferralsImportHistorical).isOpen
  const dispatch = useAppDispatch()

  return {
    isShowing: isOpen,
    show: () => dispatch(setIsOpen(true)),
    hide: () => dispatch(setIsOpen(false)),
  }
}
